import instance from 'api';
import { IRealEstatePersonalMember } from './interfaces';

export const getPersonalList = (realEstateGuid: string, pageNo: number, pageSize: number) => {
  return instance()
    .get<{ list: IRealEstatePersonalMember[]; totalCount: number }>(
      `/realEstate/personal/${realEstateGuid}/list`,
      { params: { pageNo, pageSize } },
    )
    .then((response) => response.data);
};
